<template>
	<div class="addMain">
		<el-form :model="form" :rules="rules" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-row>
				<el-col :span="4">平台名称</el-col>
				<el-col :span="20">
					<el-select v-model="form.value" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4">设备编号</el-col>
				<el-col :span="20">
					<el-input v-model="form.deviceSid"></el-input>
				</el-col>
			</el-row>
			
			<!-- <el-form-item label="地址" prop="ip"><el-input v-model="form.ip"></el-input></el-form-item> -->
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				
			},
			options: [],
			value: '',
			rules: {
				deviceSid: [
					{
						required: true,
						message: '请输入设备编号',
						trigger: 'blur'
					}
				]
			}
		};
	},
	mounted() {
		this.getPlatform()
	},
	methods:{
		getPlatform(){
			var that=this;
			this.$post("api/platform/getNameList").then(res=>{
				window.console.log(res)
				for(var i=0;i<res.length;i++){
					that.options.push({
					name:res[i].name,
					value:res[i].id
				})
				}
				// that.options={
				// 	name:res.name,
				// 	value:res.id
				// };
				window.console.log(that.options)
			})
		},
	},
};
</script>

<style scoped>
	.addMain .el-row{
		display: flex;
		align-items: center;
	}
	.addMain .el-row:first-of-type{
		margin-bottom:20px;
	}
	.addMain .el-select{
		width:100%;
	}
	.addMain .el-option{
		width:100%;
	}
</style>
